import styles from "./ExampleSuggestions.module.scss"

type Example = {
    label: string
    value: string
}

interface Props {
    examples: Example[]
    onSelect: (value: string) => void
}

export default function ExampleSuggestions({ examples, onSelect }: Props) {
    return (
        <div className={styles.container}>
            <h3 className={styles.title}>Examples</h3>
            <div className={styles.list}>
                {examples.map(e => (
                    <button
                        key={e.value}
                        type="button"
                        className={styles.item}
                        onClick={() => onSelect(e.value)}
                    >
                        <span className={styles.jp}>{e.value}</span>
                        <span className={styles.romaji}>{e.label}</span>
                    </button>
                ))}
            </div>
        </div>
    )
}
